// extracted by mini-css-extract-plugin
export var container1 = "reference-module--container1--AyrqE";
export var container2 = "reference-module--container2--3guIS";
export var reverse = "reference-module--reverse--2n9I6";
export var container3 = "reference-module--container3--3hr3O";
export var image = "reference-module--image--34jEq";
export var subtitle = "reference-module--subtitle--nfb2k";
export var noGap = "reference-module--noGap--sDK8B";
export var gapTop = "reference-module--gapTop--19APk";
export var mag = "reference-module--mag--2HmDt";